import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { QRCodeComponent } from 'angularx-qrcode';
import { NgSelectModule } from '@ng-select/ng-select';
// RECOMMENDED
import enke from '@angular/common/locales/en';
import { registerLocaleData } from '@angular/common';
registerLocaleData(enke);



import { AppComponent } from './app.component';
import { HeadermainComponent } from './shared/headermain/headermain.component';
import { HeaderhomeComponent } from './shared/headerhome/headerhome.component';
import { FooterComponent } from './shared/footer/footer.component';
import { PaymentsComponent } from './payments/payments.component';
import { HomeComponent } from './home/home.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { SpinnerComponent } from './shared/spinner/spinner.component';
import { BookingComponent } from './booking/booking.component';
import { ResultsLoaderComponent } from './shared/results-loader/results-loader.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { NobusesComponent } from './nobuses/nobuses.component';
import { SuccessComponent } from './success/success.component';
import { CounterDirective } from './directives/counter.directive';
import { AboutusComponent } from './aboutus/aboutus.component';
import { ContactusComponent } from './contactus/contactus.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { MyBookingComponent } from './my-booking/my-booking.component';
import { ConvertTimePipe } from './pipes/convert-time.pipe';
import { ParcelComponent } from './parcel/parcel.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ServiceWorkerModule } from '@angular/service-worker';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { CustomerFeedbackComponent } from './customer-feedback/customer-feedback.component';
import { CapitalizeFirstLetterPipe } from './capitalize-first-letter.pipe';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { FormComponent } from './mobile/form/form.component';
import { CitiesFromComponent } from './mobile/cities-from/cities-from.component';
import { CitiesToComponent } from './mobile/cities-to/cities-to.component';
import { FullCalendarComponent } from './mobile/full-calendar/full-calendar.component';
import { CheckPaymentComponent } from './check-payment/check-payment.component';
import { ProcessRetryComponent } from './process-retry/process-retry.component';
import { RetrySuccessfulComponent } from './retry-successful/retry-successful.component';
import { AppInitializationService } from './core/config/app-initialization.service';
import { AuthExpiryInterceptor } from './core/auth/auth-expiry.interceptor';
import { RouteLandingComponent } from './route-landing/route-landing.component';

export function initializeApplication(
  initializer: AppInitializationService
): () => Promise<void> {
  return () => initializer.initialize();
}

@NgModule({ declarations: [
        AppComponent,
        HeadermainComponent,
        HeaderhomeComponent,
        FooterComponent,
        PaymentsComponent,
        HomeComponent,
        NotFoundComponent,
        SpinnerComponent,
        BookingComponent,
        ResultsLoaderComponent,
        ConfirmComponent,
        NobusesComponent,
        SuccessComponent,
        CounterDirective,
        AboutusComponent,
        ContactusComponent,
        UserProfileComponent,
        MyBookingComponent,
        ConvertTimePipe,
        ParcelComponent,
        PrivacyPolicyComponent,
        TermsConditionComponent,
        CustomerFeedbackComponent,
        CapitalizeFirstLetterPipe,
        FormComponent,
        CitiesFromComponent,
        CitiesToComponent,
        FullCalendarComponent,
        CheckPaymentComponent,
        ProcessRetryComponent,
        RetrySuccessfulComponent,
        RouteLandingComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        ReactiveFormsModule,
        FormsModule,
        BrowserAnimationsModule,
        NgSelectModule,
        QRCodeComponent,
        MatAutocompleteModule,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })], providers: [
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApplication,
            deps: [AppInitializationService],
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthExpiryInterceptor,
            multi: true
        },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
        provideClientHydration()
    ] })
export class AppModule { }
